module.exports = __webpack_public_path__ + "static/media/matchup-icon-512.693fbe63.png";